import PropTypes from "prop-types";
import React from "react";
import { setActiveLayout } from "../../../helpers/product";

const ShopTopAction = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  data
}) => {
  return (
    <div className="shop-top-bar mb-35">
      <div className="select-shoing-wrap">
        {/* <div className="shop-select">
          <select
            onChange={e => getFilterSortParams("filterSort", e.target.value)}
          >
            <option value="default">Défaut</option>
            <option value="priceHighToLow">Price - High to Low</option>
            <option value="priceLowToHigh">Price - Low to High</option>
          </select>
        </div> */}
        <p>
          {/* {sortedProductCount} {sortedProductCount > 0 ? data.inputs['results'].value : data.inputs['result'].value} {productCount} */}
          { productCount } { productCount > 1 ? data.inputs['results'].value : data.inputs['result'].value }  
        </p>
      </div>

      <div className="shop-tab">
        {/* <button
          onClick={e => {
            getLayout("grid two-column");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th-large" />
        </button>
        <button
            className="active"
            onClick={e => {
                getLayout("grid three-column");
                setActiveLayout(e);
            }}
        >
          <i className="fa fa-th" />
        </button> */}
        {/* <button
          onClick={e => {
            getLayout("list");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-list-ul" />
        </button> */}
      </div>
    </div>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number
};

export default ShopTopAction;
